module.exports = __webpack_public_path__ + "static/img/qianhouyi2x.50249140.png";